export const isNewDeploymentType = () => {
  return window.__env && window.__env.REACT_APP_IS_NEW_DEPLOYMENT_TYPE === 'yes';
};
